export default {
  state: {
    verifiedCompanies: null,
    pinnedCompanies: null,
    selectedCompany: null
  },
  mutations: {
    setVerifiedCompanies(state, payload) {
      state.verifiedCompanies = { ...payload };
    },
    setPinnedCompanies(state, payload) {
      state.pinnedCompanies = { ...payload };
    },
    setSelectedCompany(state, payload) {
      state.selectedCompany = { ...payload };
    }
  },
  actions: {
    setVerifiedCompanies(state, payload) {
      state.commit('setVerifiedCompanies', payload);
    },
    setPinnedCompanies(state, payload) {
      state.commit('setPinnedCompanies', payload);
    },
    setSelectedCompany(state, payload) {
      state.commit('setSelectedCompany', payload);
    }
  },
  getters: {
    getVerifiedCompanies(state) {
      return state.verifiedCompanies;
    },
    getPinnedCompanies(state) {
      return state.pinnedCompanies;
    },
    getSelectedCompany(state) {
      return state.selectedCompany;
    }
  }
};
